import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { FALLBACK_LOCALE, LOCALES } from "../constants/locales";
import en from "./translations/en.json";
import pl from "./translations/pl.json";

const resources = {
  [LOCALES.en]: { translation: en },
  [LOCALES.pl]: { translation: pl },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: FALLBACK_LOCALE,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
